import React, { FC, useContext, useEffect, useState } from "react";
import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";


import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import Avatar from "./Avatar";
import FooterNav from "components_custom/FooterNav/FooterNav";
import { useNavigate } from "react-router-dom";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { requestAPI } from "utils/api";
import { GlobalDataContext } from "contexts/GlobalData";
import { ArrowSmallLeftIcon } from "@heroicons/react/24/outline";

// THIS IS DEMO FOR MAIN DEMO
// OTHER DEMO WILL PASS PROPS
const postsDemo: PostDataType[] = DEMO_POSTS.filter((_, i) => i > 7 && i < 14);
//
export interface SectionLatestPostsProps {
	posts?: PostDataType[];
	className?: string;
	postCardName?: "card3";
}

const ModifyBirthDate: FC<SectionLatestPostsProps> = ({
	posts = postsDemo,
	postCardName = "card3",
	className = "",
}) => {

	const navigate = useNavigate ();
	

	const { 
		initData,
		setInitData,
	} = useContext (GlobalDataContext);

	const [requestDateTime, setRequestDateTime] = useState ("");

	let textSub = "";

	useEffect(()=>{
		
		if (initData.token_info.permission_group === "guest") {

			navigate('/me')	
		}	
		
	}, []);


	if (initData.userInfo.birthdate === null) {
		textSub = "생년월일 설정이 없어요."
	} else {
		textSub = `현재 등록된 생년월일은 [${formatKoreanDate(initData.userInfo.birthdate).date}]이에요.`
	}

	const handleSubmit = async () => {
		const _initData = {...initData};
		const _id = _initData.userInfo._id;
		
		//console.log(requestDateTime);

		const res_info: any = await requestAPI ('PUT', `v1/user/${_id}/birthdate`, {
			requestDateTime	
		});

		if (res_info.code === 1000) {
			
			_initData.userInfo = res_info.data.userInfo;
			setInitData(_initData);
			navigate('/me');
		}
	};
	
	const handleCancel = () => {
		navigate('/me');
	};

	const handleChangeRequestDate = (e: any) => {
		
		setRequestDateTime(e.target.value)
	}

	function formatKoreanDate(dateString: string) {
		const date = new Date(dateString);
		
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const day = ('0' + date.getDate()).slice(-2);
		
		let hours = date.getHours();
		const minutes = ('0' + date.getMinutes()).slice(-2);
		const seconds = ('0' + date.getSeconds()).slice(-2);
	
		const period = hours >= 12 ? '오후' : '오전';
		hours = hours % 12 || 12; // 0 => 12
	
		const formattedDate = `${year}-${month}-${day}`;
		const formattedTime = `${period} ${hours}:${minutes}:${seconds}`;
	
		return {
			date: formattedDate,
			time: formattedTime
		};
	}

	const handleBack = () => {
		navigate(-1);
	}

	return (
		<>
			
			<div className={`container relative nc-SectionLatestPosts overflow-y ${className} h-screen bg-white !p-0 lg:w-[768px]`}>

				<div className="sticky inset-0 bg-white z-40 flex items-center justify-between">
					<div className="container flex items-center justify-between sm:w-[768px] !p-0 h-[62px]">
						<div className=" top-0 pt-4 pb-4 flex items-center justify-between bg-white">
							<button
								className="focus:outline-none focus:ring-0 w-10 h-10 rounded-full flex items-center justify-center hover:bg-neutral-100 ml-2"
								onClick={()=> handleBack()}
							>
								<ArrowSmallLeftIcon className="w-6 h-6" />
							</button>
							{/* <LikeSaveBtns /> */}
							<span
								className="text-xl"
							>
								뒤로
							</span>
						</div>
					</div>
				</div>

				<div className="flex flex-col lg:flex-row">
					<div className="w-full pl-[1rem] pr-[1rem]">
						<div className="mt-5" />
						<div
							className={`nc-Section-Heading relative flex flex-col sm:flex-row sm:items-end justify-between ${className}`}
							>
							<div
								className={`max-w-2xl`}
							>
								<h2 className={`text-3xl md:text-4xl font-semibold`}>
									생년월일 수정
								</h2>
							</div>
						</div>

						<div className="mt-10" />

						<div>
							<span
								className="text-xl font-semibold text-slate-600"
							>
								변경할 생년월일 작성해주세요.
							</span>
						</div>
						<div>
							<span 
								className="text-sm text-slate-600"
							>
								{textSub}
							</span>
						</div>


						<div className="mt-10 md:ml-10 md:mr-10">
							<div className="flex justify-center items-end w-full">
								<div className="w-full">
									<input 
										type="date" 
										className="w-[300px] rounded-md p-3 text-lg" 
										id="input-date" 
										value={requestDateTime}	
										onChange={handleChangeRequestDate}
									/>
								</div>
							</div>
						</div>
						


						
						<div className="flex flex-col mt-12 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row justify-end">
							<ButtonSecondary
								onClick={() => handleCancel()}
							>
								취소
							</ButtonSecondary>
							<ButtonPrimary
								onClick={() => handleSubmit()}
							>
								수정
							</ButtonPrimary>
						</div>						
						

					</div>

				</div>
				
			</div>
		</>
	);
};

export default ModifyBirthDate;
